import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { PutImagesRequestModel, PutImagesResponseModel } from "@/features/accounts/ocr/services/put-images-model";

export class PutImagesApi {
  /**
   * OCR読み取り画像キャンセルAPI
   */
  public putImages = async (
    param: PutImagesRequestModel
  ): Promise<PutImagesResponseModel> => {
    const path = `/api/ocraccounts/images`;
    const res = await ApiClient.instance.put<PutImagesResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
